import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { SignupBuilderMiddleware, SignupStepLoading } from '../components';

export const SignupBuilder = () => {
  return (
    <SignupBuilderMiddleware>
      <Suspense fallback={<SignupStepLoading />}>
        <Outlet />
      </Suspense>
    </SignupBuilderMiddleware>
  );
};
